<app-carousel></app-carousel>

<div class="container my-5">
  <!-- Hero section with stats -->
  <div class="row mb-5">
    <div class="col-md-12 mb-4 mb-md-0">
      <div class="stats-card">
        <div class="d-flex align-items-center">
          <div class="icon-container">
            <i class="fa-solid fa-person-running fa-3x text-primary"></i>
          </div>
          <div>
            <h2 class="text-primary fw-bold mb-1">{{todayJobOffers | number}}</h2>
            <p class="text-secondary mb-0">Ofertas publicadas en el último día</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Job Listings Section -->
  <div class="row mb-5">
    <div class="col-12 mb-4">
      <h3 class="section-title">
        <i class="fa-solid fa-briefcase me-2 text-primary"></i>
        Ofertas laborales disponibles
      </h3>
    </div>
    <div class="col-12">
      <div class="card rounded-4 mb-4">
        <div class="card-header bg-white border-0 pt-4 px-4">
          <div class="d-flex justify-content-between align-items-center">
            <p class="mb-0 text-muted">Encuentra tu próxima oportunidad profesional</p>
            <a routerLink="/home/search" class="btn btn-outline-primary btn-sm">
              Ver todas <i class="fa-solid fa-arrow-right ms-1"></i>
            </a>
          </div>
        </div>
        <div class="card-body px-4 pb-4">
          <div class="job-offers-container">
            <app-job-offer-list [appliedOffers]="false"></app-job-offer-list>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- <div class="row mb-5">
    <div class="col-12 mb-4">
      <h3 class="section-title">
        <i class="fa-solid fa-tags me-2 text-primary"></i>
        Categorías destacadas
      </h3>
    </div>
    <div class="col-12">
      <div class="row g-4">
        @for (category of [
          {name: 'Tecnología', icon: 'fa-solid fa-laptop-code'},
          {name: 'Ventas', icon: 'fa-solid fa-chart-line'},
          {name: 'Administración', icon: 'fa-solid fa-briefcase'},
          {name: 'Marketing', icon: 'fa-solid fa-bullhorn'},
          {name: 'Desarrollo', icon: 'fa-solid fa-code'},
          {name: 'Recursos Humanos', icon: 'fa-solid fa-users'}
        ]; track $index) {
          <div class="col-md-4 col-sm-6 mb-4">
            <div class="category-card">
              <div class="category-icon">
                <i class="{{category.icon}}"></i>
              </div>
              <span class="fw-medium">{{category.name}}</span>
              <i class="fa-solid fa-chevron-right text-primary ms-auto"></i>
            </div>
          </div>
        }
      </div>
    </div>
  </div> -->
</div>

